import React, { useState, useEffect, useCallback, useRef } from "react";
import { useCCVendors } from "./ConstantContactAuth";

const API = "https://bioev-portal-production.up.railway.app/api";

function TrashIcon({ size = 15, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" /><path d="M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  );
}

// ─── Static Fallback Data ─────────────────────────────────────────────────────
const initialVendors = [
  { id: 1,  name: "Dr. Sarah Chen",     company: "Bio-Rad Laboratories", email: "schen@bio-rad.com",           billingEmail: "schen@bio-rad.com",          event: "BioBeats Series: San Diego",     status: "Confirmed",  paymentPref: "Payment Link",       linkSent: false },
  { id: 2,  name: "Marcus Johnson",     company: "Thermo Fisher",         email: "mjohnson@thermofisher.com",  billingEmail: "ap@thermofisher.com",        event: "BioBeats Series: San Diego",     status: "Paid",       paymentPref: "Credit Card on File", linkSent: false },
  { id: 3,  name: "Dr. Aiko Patel",     company: "Eppendorf",             email: "apatel@eppendorf.com",       billingEmail: "ap@eppendorf.com",           event: "AACC Annual Scientific Meeting", status: "Confirmed",  paymentPref: "Payment Link",       linkSent: true  },
  { id: 4,  name: "Robert Kim",         company: "Illumina",              email: "rkim@illumina.com",          billingEmail: "rkim@illumina.com",          event: "MD&M West",                      status: "Confirmed",  paymentPref: "Payment Link",       linkSent: false },
  { id: 5,  name: "Dr. Elena Vasquez", company: "Agilent Technologies", email: "evasquez@agilent.com",       billingEmail: "evasquez@agilent.com",       event: "Bio International Convention",   status: "Confirmed",  paymentPref: "Payment Link",       linkSent: false },
  { id: 6,  name: "James Wright",       company: "Waters Corporation",   email: "jwright@waters.com",         billingEmail: "jwright@waters.com",         event: "BioBeats Series: Boston",        status: "Paid",       paymentPref: "Credit Card on File", linkSent: false },
  { id: 7,  name: "Dr. Lisa Park",      company: "Bruker",                email: "lpark@bruker.com",           billingEmail: "lpark@bruker.com",           event: "SLAS Annual Conference",          status: "Confirmed",  paymentPref: "Payment Link",       linkSent: false },
  { id: 8,  name: "Michael Torres",     company: "Beckman Coulter",       email: "mtorres@beckmancoulter.com", billingEmail: "mtorres@beckmancoulter.com", event: "BioBeats Series: NYC",            status: "Confirmed",  paymentPref: "Payment Link",       linkSent: false },
  { id: 9,  name: "Dr. Rachel Green",   company: "Promega",               email: "rgreen@promega.com",         billingEmail: "rgreen@promega.com",         event: "ASHP Midyear Clinical Meeting",  status: "Confirmed",  paymentPref: "Payment Link",       linkSent: true  },
  { id: 10, name: "Thomas Anderson",   company: "Sartorius",             email: "tanderson@sartorius.com",    billingEmail: "tanderson@sartorius.com",    event: "BioBeats Series: Austin",        status: "Confirmed",  paymentPref: "Payment Link",       linkSent: false },
];

const INITIAL_EVENT_DATA = {
  "BioBeats Series: San Diego":     { date: "2025-01-18", costPerTable: 2500, capacity: 20, status: "Completed", address: "San Diego Convention Center, 111 W Harbor Dr, San Diego, CA 92101",                                        startTime: "08:00", endTime: "17:00" },
  "BioBeats Series: Boston":        { date: "2025-02-22", costPerTable: 2800, capacity: 20, status: "Completed", address: "Hynes Convention Center, 900 Boylston St, Boston, MA 02115",                                                startTime: "08:00", endTime: "17:00" },
  "AACC Annual Scientific Meeting": { date: "2025-03-15", costPerTable: 3200, capacity: 30, status: "Completed", address: "McCormick Place, 2301 S King Dr, Chicago, IL 60616",                                                        startTime: "08:00", endTime: "17:00" },
  "MD&M West":                      { date: "2025-04-05", costPerTable: 2200, capacity: 25, status: "Completed", address: "Anaheim Convention Center, 800 W Katella Ave, Anaheim, CA 92802",                                           startTime: "08:00", endTime: "17:00" },
  "Bio International Convention":  { date: "2025-05-10", costPerTable: 4500, capacity: 40, status: "Completed", address: "San Diego Convention Center, 111 W Harbor Dr, San Diego, CA 92101",                                        startTime: "08:00", endTime: "17:00" },
  "BioBeats Series: NYC":           { date: "2025-08-14", costPerTable: 3500, capacity: 25, status: "Completed", address: "Javits Center, 429 11th Ave, New York, NY 10001",                                                           startTime: "08:00", endTime: "17:00" },
  "ASHP Midyear Clinical Meeting":  { date: "2025-11-18", costPerTable: 2900, capacity: 30, status: "Completed", address: "New Orleans Ernest N. Morial Convention Center, 900 Convention Center Blvd, New Orleans, LA 70130",         startTime: "08:00", endTime: "17:00" },
  "BioBeats Series: Chicago":       { date: "2026-03-12", costPerTable: 3000, capacity: 3,  status: "Completed", address: "McCormick Place, 2301 S King Dr, Chicago, IL 60616",                                                        startTime: "08:00", endTime: "17:00" },
  "SLAS Annual Conference":         { date: "2026-06-08", costPerTable: 3100, capacity: 20, status: "Upcoming",  address: "Boston Convention & Exhibition Center, 415 Summer St, Boston, MA 02210",                                    startTime: "08:00", endTime: "17:00" },
  "BioBeats Series: Austin":        { date: "2026-09-19", costPerTable: 2700, capacity: 15, status: "Upcoming",  address: "Austin Convention Center, 500 E Cesar Chavez St, Austin, TX 78701",                                         startTime: "08:00", endTime: "17:00" },
};

const CAPACITY_STATUSES = new Set(["Confirmed", "Paid", "Comp"]);
const STATUS_OPTIONS = ["Confirmed", "Waitlisted", "Paid", "Canceled", "Comp"];
const STATUS_STYLES = {
  "Paid":       { bg: "#0a3d22",            color: "#5ae3a8", border: "#1a6640" },
  "Confirmed":  { bg: "rgba(22,168,228,.1)", color: "#16a8e4", border: "#1a5070" },
  "Waitlisted": { bg: "#1a1a3d",            color: "#8a8ae3", border: "#2a2a6a" },
  "Canceled":   { bg: "#3d0a0a",            color: "#e37e7e", border: "#6a1a1a" },
  "Comp":      { bg: "rgba(75,85,99,0.1)", color: "#9ca3af", border: "1px solid rgba(75,85,99,0.3)" },
    "Completed": { bg: "rgba(75,85,99,0.1)", color: "#9ca3af", border: "1px solid rgba(75,85,99,0.3)" },
  };

// ─── Helpers ──────────────────────────────────────────────────────────────────
function getDateStatus(dateStr) {
  if (!dateStr) return "upcoming";
  const eventDate = new Date(dateStr + "T00:00:00");
  if (isNaN(eventDate.getTime())) return "upcoming";
  const today    = new Date();
  const eventDay = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());
  const todayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  if (eventDay < todayDay) return "completed";
  if (eventDay.getTime() === todayDay.getTime()) return "today";
  return "upcoming";
}

function formatTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":");
  const hour    = parseInt(h);
  const ampm    = hour >= 12 ? "PM" : "AM";
  const display = hour % 12 || 12;
  return `${display}:${m} ${ampm}`;
}

function searchCCContacts(query, ccVendors) {
  if (!query || query.trim().length < 2 || !ccVendors?.length) return [];
  const q = query.trim().toLowerCase();
  return ccVendors.filter(c =>
    (c.name    && c.name.toLowerCase().includes(q))    ||
    (c.company && c.company.toLowerCase().includes(q)) ||
    (c.email   && c.email.toLowerCase().includes(q))
  ).slice(0, 10);
}

// ─── DB API Helpers ───────────────────────────────────────────────────────────
async function dbSaveVendor(vendor) {
  try {
    await fetch(`${API}/vendors`, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify(vendor),
    });
  } catch (err) { console.error("DB save vendor error:", err); }
}

async function dbUpdateVendor(id, update) {
  try {
    await fetch(`${API}/vendors/${id}`, {
      method:  "PUT",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify(update),
    });
  } catch (err) { console.error("DB update vendor error:", err); }
}
async function dbDeleteVendor(id) {
  try {
    await fetch(`${API}/vendors/${id}`, {
      method: "DELETE",
    });
  } catch (err) { console.error("DB delete vendor error:", err); }
}
async function dbSaveEvent(name, details) {
  try {
    await fetch(`${API}/events`, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ name, ...details }),
    });
  } catch (err) { console.error("DB save event error:", err); }
}
async function dbDeleteEvent(name) {
  try {
    await fetch(`${API}/events/${encodeURIComponent(name)}`, { method: "DELETE" });
  } catch (err) { console.error("DB delete event error:", err); }
}

// ─── Shared UI ────────────────────────────────────────────────────────────────
function ToastItem({ toast, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, toast.duration || 4500);
    return () => clearTimeout(t);
  }, [onClose, toast.duration]);
  const cfgMap = {
    success: { border: "#16a8e4", iconColor: "#16a8e4", title: "Success" },
    info:    { border: "#16a8e4", iconColor: "#16a8e4", title: "Notification" },
    error:   { border: "#e37e7e", iconColor: "#e37e7e", title: "Action Blocked" },
  };
  const cfg = cfgMap[toast.type] || cfgMap.info;
  return (
    <div style={{ background: "#111e32", border: `1px solid ${cfg.border}`, borderRadius: 12, padding: "14px 18px", boxShadow: "0 8px 40px rgba(0,0,0,.5)", minWidth: 300, display: "flex", alignItems: "flex-start", gap: 11, animation: "slideUp 0.3s ease-out" }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontFamily: "'DM Mono',monospace", fontWeight: 600, fontSize: 11, color: cfg.iconColor, marginBottom: 3 }}>{cfg.title.toUpperCase()}</div>
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: "#a0c8e0", lineHeight: 1.4 }}>{toast.message}</div>
      </div>
      <button onClick={onClose} style={{ background: "none", border: "none", color: "#3a6a8a", cursor: "pointer", fontSize: 16 }}>✕</button>
    </div>
  );
}

function ToastStack({ toasts, onClose }) {
  return (
    <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999, display: "flex", flexDirection: "column", gap: 10 }}>
      {toasts.map(t => <ToastItem key={t.id} toast={t} onClose={() => onClose(t.id)} />)}
    </div>
  );
}

function PaymentPrefBadge({ pref }) {
  const isCC = pref === "Credit Card on File";
  return (
    <span style={{ padding: "3px 9px", borderRadius: 20, border: `1px solid ${isCC ? "#2a3a70" : "#1a4060"}`, background: isCC ? "rgba(90,130,228,.08)" : "rgba(22,168,228,.08)", color: isCC ? "#8aaaff" : "#5aaad0", fontFamily: "'DM Mono',monospace", fontSize: 10, letterSpacing: "0.06em", whiteSpace: "nowrap" }}>{pref}</span>
  );
}

function CCStatusBanner({ isAuthenticated, isLoading, ccVendorCount, onLogin, onLogout, onRefresh }) {
  if (isLoading) return (
    <div style={{ background: "rgba(22,168,228,0.05)", borderBottom: "1px solid #0e2030", padding: "8px 32px", display: "flex", alignItems: "center", gap: 10 }}>
      <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#4a7a8a", animation: "pulse 1.5s infinite" }} />
      <span style={{ fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#4a7a8a" }}>Connecting to Constant Contact...</span>
    </div>
  );
  if (isAuthenticated) return (
    <div style={{ background: "rgba(22,168,228,0.05)", borderBottom: "1px solid #0e2030", padding: "8px 32px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#5ae3a8" }} />
        <span style={{ fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#5ae3a8" }}>CONSTANT CONTACT CONNECTED — {ccVendorCount} vendors available</span>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
  <button onClick={onRefresh} style={{ background: "none", border: "1px solid #1a4060", color: "#4a7a8a", borderRadius: 6, padding: "3px 10px", fontSize: 10, cursor: "pointer", fontFamily: "'DM Mono',monospace" }}>↻ Refresh</button>
  <button onClick={onLogout} style={{ background: "none", border: "1px solid #1a4060", color: "#4a7a8a", borderRadius: 6, padding: "3px 10px", fontSize: 10, cursor: "pointer", fontFamily: "'DM Mono',monospace" }}>Disconnect</button>
</div>
    </div>
  );
  return (
    <div style={{ background: "rgba(22,168,228,0.03)", borderBottom: "1px solid #0e2030", padding: "8px 32px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#4a5a6a" }} />
        <span style={{ fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#4a6a7a" }}>Vendor database not connected — search uses local data only</span>
      </div>
      <button onClick={onLogin} style={{ background: "linear-gradient(135deg,#0e8abf,#16a8e4)", border: "none", color: "#fff", borderRadius: 6, padding: "5px 14px", fontSize: 11, cursor: "pointer", fontFamily: "'DM Mono',monospace", fontWeight: 700 }}>Connect Constant Contact</button>
    </div>
  );
}

// ─── Modals ───────────────────────────────────────────────────────────────────
function SplitPaymentModal({ vendor, eventInfo, onClose, onSend, initialColleagues, ccVendors }) {
  const total = eventInfo?.costPerTable || 1000;
  const makeColleague = () => ({ name: "", email: "", amt: 0, paymentPref: "Payment Link" });
  const [colleagues, setColleagues] = useState(initialColleagues?.length > 0 ? initialColleagues : [makeColleague()]);
  const [activeSearchIdx, setActiveSearchIdx] = useState(null);
  const [ccResults, setCcResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const searchTimer = useRef(null);

  const handleColleagueNameInput = (idx, val) => {
    updateColleague(idx, "name", val);
    clearTimeout(searchTimer.current);
    if (val.trim().length < 2) { setCcResults([]); setActiveSearchIdx(null); return; }
    setIsSearching(true); setActiveSearchIdx(idx);
    searchTimer.current = setTimeout(() => { setCcResults(searchCCContacts(val, ccVendors)); setIsSearching(false); }, 300);
  };
  const pickColleague = (idx, contact) => {
    setColleagues(prev => prev.map((c, i) => i === idx ? { ...c, name: contact.name, email: contact.email, company: contact.company } : c));
    setCcResults([]); setActiveSearchIdx(null);
  };
  const updateColleague    = (idx, field, value) => setColleagues(prev => prev.map((c, i) => i === idx ? { ...c, [field]: value } : c));
  const updateColleagueAmt = (idx, value) => {
    const n = Math.max(0, Math.min(total, Number(value) || 0));
    setColleagues(prev => prev.map((c, i) => i === idx ? { ...c, amt: n } : c));
  };
  const totalColleagueAmt = colleagues.reduce((s, c) => s + (Number(c.amt) || 0), 0);
  const derivedVendorAmt  = Math.max(0, total - totalColleagueAmt);
  const vendorPct         = total > 0 ? Math.round((derivedVendorAmt / total) * 100) : 0;
  const canSend           = colleagues.every(c => c.name.trim() && c.email.trim()) && totalColleagueAmt <= total;
  const inp = { width: "100%", padding: "9px 13px", borderRadius: 8, border: "1px solid #1a4060", background: "#040e1a", color: "#c8dce8", fontFamily: "'DM Sans',sans-serif", fontSize: 13, outline: "none", boxSizing: "border-box" };
  const lbl = { fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#4a8a9a", letterSpacing: "0.08em", marginBottom: 5, display: "block" };
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 900, background: "rgba(4,14,26,.85)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: "linear-gradient(160deg,#0d2137,#081929)", border: "1px solid #1a4060", borderRadius: 16, width: 560, maxHeight: "90vh", display: "flex", flexDirection: "column", boxShadow: "0 24px 80px rgba(0,0,0,.7)" }}>
        <div style={{ padding: "18px 24px 15px", borderBottom: "1px solid #132840", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 15, color: "#c8dce8" }}>Split Payment</div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: "#4a7a8a", marginTop: 3 }}>{vendor.event} • ${total.toLocaleString()} total</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#4a7a8a", cursor: "pointer", fontSize: 20 }}>×</button>
        </div>
        <div style={{ padding: "20px 24px", overflowY: "auto", flex: 1, display: "flex", flexDirection: "column", gap: 18 }}>
          <div style={{ background: "rgba(22,168,228,.05)", padding: "12px 15px", borderRadius: 10, border: "1px solid #16a8e433", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: 13, color: "#16a8e4", fontWeight: 600 }}>{vendor.name} (Primary)</div>
            <div style={{ fontWeight: 700, color: "#16a8e4", fontFamily: "'DM Mono', monospace" }}>${derivedVendorAmt.toLocaleString()} <span style={{ fontSize: 10, color: "#4a8a9a", marginLeft: 4 }}>{vendorPct}%</span></div>
          </div>
          {colleagues.map((col, idx) => (
            <div key={idx} style={{ background: "rgba(10,30,50,.5)", padding: "15px", borderRadius: 10, border: "1px solid #0e2538", position: "relative" }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
                <div style={{ position: "relative" }}>
                  <label style={lbl}>NAME</label>
                  <input style={inp} value={col.name} onChange={e => handleColleagueNameInput(idx, e.target.value)} placeholder="Search CC contacts..." />
                  {activeSearchIdx === idx && (ccResults.length > 0 || isSearching) && (
                    <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#0a1e32", border: "1px solid #16a8e444", borderRadius: 10, zIndex: 100, overflow: "hidden", marginTop: 4, boxShadow: "0 8px 32px rgba(0,0,0,.6)" }}>
                      {isSearching ? <div style={{ padding: "10px", color: "#4a7a8a", fontSize: 12 }}>Searching...</div>
                        : ccResults.map((r, i) => (
                          <div key={i} onMouseDown={() => pickColleague(idx, r)} style={{ padding: "10px 12px", cursor: "pointer", borderBottom: "1px solid #0e2538", fontSize: 13, color: "#c8dce8" }} onMouseEnter={e => e.currentTarget.style.background = "#16a8e422"} onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <div>{r.name}</div><div style={{ fontSize: 11, color: "#4a7a8a" }}>{r.company}</div>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
                <div><label style={lbl}>EMAIL</label><input style={inp} value={col.email} onChange={e => updateColleague(idx, "email", e.target.value)} /></div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10, alignItems: "end" }}>
                <div>
                  <label style={lbl}>PAYMENT PREFERENCE</label>
                  <select style={inp} value={col.paymentPref} onChange={e => updateColleague(idx, "paymentPref", e.target.value)}>
                    <option value="Payment Link">Payment Link</option>
                    <option value="Credit Card on File">Credit Card on File</option>
                  </select>
                </div>
                <div><label style={lbl}>AMOUNT ($)</label><input style={{ ...inp, width: 100, textAlign: "center" }} type="number" value={col.amt} onChange={e => updateColleagueAmt(idx, e.target.value)} /></div>
              </div>
              {colleagues.length > 1 && <button onClick={() => setColleagues(colleagues.filter((_, i) => i !== idx))} style={{ position: "absolute", top: 12, right: 12, background: "none", border: "none", cursor: "pointer" }}><TrashIcon color="#3a6a8a" size={13} /></button>}
            </div>
          ))}
          <button onClick={() => setColleagues([...colleagues, makeColleague()])} style={{ alignSelf: "flex-start", background: "none", color: "#16a8e4", border: "1px dashed #16a8e444", padding: "10px 15px", borderRadius: 8, cursor: "pointer", fontSize: 12 }}>+ Add Split Partner</button>
        </div>
        <div style={{ padding: "15px 24px", borderTop: "1px solid #0e2030", display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button onClick={onClose} style={{ padding: "9px 20px", borderRadius: 8, border: "1px solid #1a4060", color: "#6a9ab0", background: "none", cursor: "pointer" }}>Cancel</button>
          <button onClick={() => onSend(vendor, colleagues, derivedVendorAmt)} disabled={!canSend} style={{ padding: "9px 25px", borderRadius: 8, border: "none", background: canSend ? "linear-gradient(135deg,#0e8abf,#16a8e4)" : "#1a3040", color: "#fff", fontWeight: 700, cursor: canSend ? "pointer" : "not-allowed" }}>Save Splits</button>
        </div>
      </div>
    </div>
  );
}

function AddVendorModal({ onClose, onAdd, upcomingEvents, pastEvents, defaultEvent, ccVendors }) {
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [billingSame, setBillingSame] = useState(true);
  const [billingEmail, setBillingEmail] = useState("");
  const [event, setEvent] = useState(defaultEvent || upcomingEvents[0] || "");
  const [paymentPref, setPaymentPref] = useState("Payment Link");
  const [errors, setErrors] = useState({});
  const [ccQuery, setCcQuery] = useState("");
  const [ccResults, setCcResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const searchTimer = useRef(null);

  const handleCcInput = (val) => {
    setCcQuery(val); setShowDropdown(true);
    clearTimeout(searchTimer.current);
    if (val.trim().length < 2) { setCcResults([]); return; }
    searchTimer.current = setTimeout(() => { setCcResults(searchCCContacts(val, ccVendors)); }, 300);
  };
  const pickContact = (c) => {
    setCcQuery(c.name); setShowDropdown(false);
    setName(c.name); setCompany(c.company); setEmail(c.email);
    if (billingSame) setBillingEmail(c.email);
  };
  const handleSubmit = () => {
    if (!name.trim() || !email.trim()) { setErrors({ name: !name, email: !email }); return; }
    onAdd({ name, company, email, billingEmail: billingSame ? email : billingEmail, event, paymentPref });
    onClose();
  };
  const inp = hasErr => ({ width: "100%", padding: "10px 13px", borderRadius: 8, border: `1px solid ${hasErr ? "#6a1a1a" : "#1a4060"}`, background: "#040e1a", color: "#c8dce8", fontSize: 13, outline: "none", boxSizing: "border-box", marginBottom: 12 });
  const lbl = (text) => <label style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 10, color: "#4a8a9a", letterSpacing: "0.08em", marginBottom: 4, display: "block" }}>{text}</label>;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 900, background: "rgba(4,14,26,.85)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: "linear-gradient(160deg,#0d2137,#081929)", border: "1px solid #1a4060", borderRadius: 16, width: 480, boxShadow: "0 24px 80px rgba(0,0,0,.7)", padding: "24px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
          <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 18, color: "#c8dce8" }}>Add Vendor</div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#4a7a8a", cursor: "pointer", fontSize: 20 }}>×</button>
        </div>
        <div style={{ position: "relative", marginBottom: 20 }}>
          {lbl("SEARCH CONSTANT CONTACT DATABASE")}
          <input style={{ ...inp(false), marginBottom: 0 }} value={ccQuery} onChange={e => handleCcInput(e.target.value)} placeholder="Search by name, company, or email..." />
          {showDropdown && ccResults.length > 0 && (
            <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#0a1e32", border: "1px solid #16a8e444", borderRadius: 8, zIndex: 100, overflow: "hidden" }}>
              {ccResults.map((r, i) => (
                <div key={i} onMouseDown={() => pickContact(r)} style={{ padding: "10px", cursor: "pointer", borderBottom: "1px solid #0e2538" }} onMouseEnter={e => e.currentTarget.style.background = "#16a8e411"} onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <div style={{ fontSize: 13, color: "#c8dce8" }}>{r.name}</div>
                  <div style={{ fontSize: 11, color: "#4a8aaa" }}>{r.company}</div>
                </div>
              ))}
            </div>
          )}
          {showDropdown && ccQuery.length >= 2 && ccResults.length === 0 && (
            <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#0a1e32", border: "1px solid #16a8e422", borderRadius: 8, zIndex: 100, padding: "10px 12px" }}>
              <span style={{ fontSize: 12, color: "#4a6a7a" }}>No contacts found in Constant Contact</span>
            </div>
          )}
        </div>
        <div style={{ height: 1, background: "#1a4060", marginBottom: 20 }} />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>{lbl("FULL NAME")}<input style={inp(errors.name)} value={name} onChange={e => setName(e.target.value)} /></div>
          <div>{lbl("COMPANY")}<input style={inp(false)} value={company} onChange={e => setCompany(e.target.value)} /></div>
        </div>
        {lbl("EMAIL")}<input style={inp(errors.email)} value={email} onChange={e => setEmail(e.target.value)} />
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 15 }}>
          <input type="checkbox" checked={billingSame} onChange={e => setBillingSame(e.target.checked)} />
          <span style={{ fontSize: 12, color: "#6a9ab0" }}>Billing email same as contact</span>
        </div>
        {!billingSame && (
  <div style={{ marginBottom: 15 }}>
    {lbl("BILLING EMAIL")}
    <input style={inp(errors.billingEmail)} value={billingEmail} onChange={e => setBillingEmail(e.target.value)} placeholder="billing@example.com" />
  </div>
)}
        {lbl("EVENT")}<select style={inp(false)} value={event} onChange={e => setEvent(e.target.value)}>{[...upcomingEvents, ...pastEvents].map(ev => <option key={ev} value={ev}>{ev}</option>)}</select>
        {lbl("PREFERENCE")}<select style={inp(false)} value={paymentPref} onChange={e => setPaymentPref(e.target.value)}><option value="Payment Link">Payment Link</option><option value="Credit Card on File">Credit Card on File</option></select>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
          <button onClick={onClose} style={{ background: "none", color: "#6a9ab0", border: "none", cursor: "pointer" }}>Cancel</button>
          <button onClick={handleSubmit} style={{ background: "linear-gradient(135deg,#0e8abf,#16a8e4)", color: "#fff", border: "none", padding: "10px 20px", borderRadius: 8, fontWeight: 700, cursor: "pointer" }}>Add Vendor</button>
        </div>
      </div>
    </div>
  );
}

function EditVendorModal({ vendor, onClose, onSave, onDelete }) {
  const [name, setName] = useState(vendor.name || "");
  const [company, setCompany] = useState(vendor.company || "");
  const [email, setEmail] = useState(vendor.email || "");
  const [billingEmail, setBillingEmail] = useState(vendor.billingEmail || "");
  const [billingSame, setBillingSame] = useState(!vendor.billingEmail || vendor.billingEmail === vendor.email);
  const [pref, setPref] = useState(vendor.paymentPref || "Payment Link");
  const [customAmount, setCustomAmount] = useState(vendor.customAmount || vendor.amt || "");
  const canSubmit = name.trim() && email.trim();
  const inp = { width: "100%", padding: "10px 13px", borderRadius: 8, border: "1px solid #1a4060", background: "#040e1a", color: "#c8dce8", marginBottom: 15, outline: "none", boxSizing: "border-box", fontSize: 13 };
  const lbl = (text) => <label style={{ fontSize: 10, color: "#4a8a9a", letterSpacing: "0.08em", marginBottom: 4, display: "block", fontFamily: "'DM Mono', monospace" }}>{text}</label>;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 900, background: "rgba(4,14,26,.85)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#0d2137", border: "1px solid #1a4060", borderRadius: 16, width: 400, padding: "24px", boxSizing: "border-box" }}>
        <h3 style={{ marginTop: 0, color: "#c8dce8", fontFamily: "'Syne', sans-serif" }}>Edit Vendor Profile</h3>
        {lbl("FULL NAME")}<input style={inp} value={name} onChange={e => setName(e.target.value)} />
{lbl("COMPANY")}<input style={inp} value={company} onChange={e => setCompany(e.target.value)} />
{lbl("EMAIL")}<input style={inp} value={email} onChange={e => setEmail(e.target.value)} />
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 15 }}>
          <input type="checkbox" checked={billingSame} onChange={e => setBillingSame(e.target.checked)} />
          <span style={{ fontSize: 12, color: "#6a9ab0" }}>Billing email same as contact</span>
        </div>
        {!billingSame && (
          <div style={{ marginBottom: 15 }}>
            {lbl("BILLING EMAIL")}
            <input style={inp} value={billingEmail} onChange={e => setBillingEmail(e.target.value)} placeholder="billing@example.com" />
          </div>
        )}
        {lbl("CUSTOM AMOUNT (leave blank for event default)")}
<input type="number" style={inp} value={customAmount} onChange={e => setCustomAmount(e.target.value)} placeholder="Event default" />
        {lbl("PAYMENT PREFERENCE")}
        <select style={inp} value={pref} onChange={e => setPref(e.target.value)}>
          <option value="Payment Link">Payment Link</option>
          <option value="Credit Card on File">Credit Card on File</option>
        </select>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button onClick={() => { if (window.confirm(`Permanently delete ${vendor.name} from this event? This cannot be undone.`)) { onDelete(vendor.id); } }} style={{ background: "none", border: "1px solid #7f1d1d", color: "#f87171", padding: "8px 14px", borderRadius: 6, cursor: "pointer", fontSize: 12 }}>Delete Vendor</button>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={onClose} style={{ background: "none", color: "#6a9ab0", border: "none", cursor: "pointer" }}>Cancel</button>
            <button onClick={() => onSave(vendor.id, { name, company, email, billingEmail: billingSame ? email : billingEmail, paymentPref: pref, customAmount })} disabled={!canSubmit} style={{ background: canSubmit ? "#0ea5e9" : "#1a4060", color: canSubmit ? "#fff" : "#4a7a90", border: "none", padding: "8px 18px", borderRadius: 8, cursor: canSubmit ? "pointer" : "not-allowed", fontWeight: 600 }}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function EditEventModal({ eventName, eventInfo, onClose, onSave, onDelete }) {
  const [date,      setDate]      = useState(eventInfo.date || "");
  const [capacity,  setCapacity]  = useState(eventInfo.capacity || 0);
  const [cost,      setCost]      = useState(eventInfo.costPerTable || 0);
  const [address,   setAddress]   = useState(eventInfo.address || "");
  const [startTime, setStartTime] = useState(eventInfo.startTime || "");
  const [endTime,   setEndTime]   = useState(eventInfo.endTime || "");
  const [status,    setStatus]    = useState(eventInfo.status || "Upcoming");
  const inp = { width: "100%", padding: "10px 13px", borderRadius: 8, border: "1px solid #1a4060", background: "#040e1a", color: "#c8dce8", fontSize: 13, marginBottom: 15, outline: "none", boxSizing: "border-box" };
  const lbl = (text) => <label style={{ fontSize: 10, color: "#4a8a9a", letterSpacing: "0.08em", marginBottom: 4, display: "block", fontFamily: "'DM Mono', monospace" }}>{text}</label>;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(4,14,26,.85)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: "linear-gradient(160deg,#0d2137,#081929)", border: "1px solid #1a4060", borderRadius: 16, width: 440, padding: 24, boxShadow: "0 24px 80px rgba(0,0,0,.7)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
          <div>
            <h3 style={{ margin: 0, color: "#c8dce8", fontFamily: "'Syne', sans-serif", fontSize: 18 }}>Edit Event</h3>
            <div style={{ fontSize: 12, color: "#4a7a8a", marginTop: 4 }}>{eventName}</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#4a7a8a", cursor: "pointer", fontSize: 20 }}>×</button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>{lbl("DATE")}<input type="date" style={inp} value={date} onChange={e => setDate(e.target.value)} /></div>
          <div>{lbl("CAPACITY")}<input type="number" style={inp} value={capacity} onChange={e => setCapacity(Number(e.target.value))} /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>{lbl("START TIME")}<input type="time" style={inp} value={startTime} onChange={e => setStartTime(e.target.value)} /></div>
          <div>{lbl("END TIME")}<input type="time" style={inp} value={endTime} onChange={e => setEndTime(e.target.value)} /></div>
        </div>
        {lbl("COST PER TABLE ($)")}<input type="number" style={inp} value={cost} onChange={e => setCost(Number(e.target.value))} />
        {lbl("STATUS")}
        <select style={inp} value={status} onChange={e => setStatus(e.target.value)}>
  <option value="Upcoming">Upcoming</option>
  <option value="Completed">Completed</option>
  <option value="Canceled">Canceled</option>
</select>
        {lbl("FULL ADDRESS")}<input style={inp} value={address} onChange={e => setAddress(e.target.value)} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
          <button onClick={() => { if (window.confirm(`Permanently delete ${eventName}? This cannot be undone.`)) { onDelete(eventName); } }} style={{ background: "none", border: "1px solid #7f1d1d", color: "#f87171", padding: "8px 14px", borderRadius: 6, cursor: "pointer", fontSize: 12 }}>Delete Event</button>
          <div style={{ display: "flex", gap: 12 }}>
            <button onClick={onClose} style={{ background: "none", color: "#6a9ab0", border: "none", cursor: "pointer", fontSize: 13 }}>Cancel</button>
            <button onClick={() => onSave(eventName, { date, capacity, costPerTable: cost, address, startTime, endTime, status })} style={{ background: "#16a8e4", color: "#fff", border: "none", padding: "10px 22px", borderRadius: 8, fontWeight: 700, cursor: "pointer", fontSize: 13 }}>Save Changes</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function AddEventModal({ onClose, onAdd }) {
  const [name,      setName]      = useState("");
  const [date,      setDate]      = useState("");
  const [cost, setCost] = useState(2500);
  const [capacity,  setCapacity]  = useState(15);
  const [address,   setAddress]   = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime,   setEndTime]   = useState("");
  const inp = { width: "100%", padding: "10px 13px", borderRadius: 8, border: "1px solid #1a4060", background: "#040e1a", color: "#c8dce8", fontSize: 13, marginBottom: 15, outline: "none", boxSizing: "border-box" };
  const lbl = (text) => <label style={{ fontSize: 10, color: "#4a8a9a", letterSpacing: "0.08em", marginBottom: 4, display: "block", fontFamily: "'DM Mono', monospace" }}>{text}</label>;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(4,14,26,.85)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: "linear-gradient(160deg,#0d2137,#081929)", border: "1px solid #1a4060", borderRadius: 16, width: 440, padding: 24, boxShadow: "0 24px 80px rgba(0,0,0,.7)" }}>
        <h3 style={{ marginTop: 0, color: "#c8dce8", fontFamily: "'Syne', sans-serif", fontSize: 18 }}>Add New Event</h3>
        {lbl("EVENT NAME (e.g. BioBeats Series: Austin)")}<input style={inp} value={name} onChange={e => setName(e.target.value)} placeholder="Series Name: City" />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>{lbl("DATE")}<input type="date" style={inp} value={date} onChange={e => setDate(e.target.value)} /></div>
          <div>{lbl("CAPACITY")}<input type="number" style={inp} value={capacity} onChange={e => setCapacity(Number(e.target.value))} /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>{lbl("START TIME")}<input type="time" style={inp} value={startTime} onChange={e => setStartTime(e.target.value)} /></div>
          <div>{lbl("END TIME")}<input type="time" style={inp} value={endTime} onChange={e => setEndTime(e.target.value)} /></div>
        </div>
        {lbl("COST PER TABLE ($)")}<input type="number" style={inp} value={cost} onChange={e => setCost(Number(e.target.value))} />
        {lbl("FULL ADDRESS")}<input style={inp} value={address} onChange={e => setAddress(e.target.value)} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
          <button onClick={onClose} style={{ background: "none", color: "#6a9ab0", border: "none", cursor: "pointer", fontSize: 13 }}>Cancel</button>
          <button onClick={() => onAdd(name, { date, cost, capacity, address, startTime, endTime })} disabled={!name || !date} style={{ background: (name && date) ? "#16a8e4" : "#1a3040", color: "#fff", border: "none", padding: "10px 22px", borderRadius: 8, fontWeight: 700, cursor: (name && date) ? "pointer" : "not-allowed", fontSize: 13 }}>Create Event</button>
        </div>
      </div>
    </div>
  );
}

// ─── Event Accordion ──────────────────────────────────────────────────────────
function EventAccordion({
  eventName, eventInfo, vendors, allVendors, searchQuery,
  onStatusChange, onSplitModal, onReceiptModal, onEditVendor,
  onPaymentLinkSend, onRunCC, onAddVendor, onEditEvent,
  onColleagueStatusChange, onColleaguePaymentLinkSend
}) {
  const [open, setOpen] = useState(false);
  const q           = searchQuery.toLowerCase();
  const hasMatch = q && vendors.some(v => v.name.toLowerCase().includes(q) || (v.company && v.company.toLowerCase().includes(q)));
useEffect(() => { if (q) { setOpen(!!hasMatch); } else { setOpen(false); } }, [q, hasMatch]);
  const isCompleted = eventInfo?.status === "Completed";
const isCanceled  = eventInfo?.status === "Canceled";
  const dateStatus  = getDateStatus(eventInfo?.date);
  const isPast      = isCompleted || dateStatus === "completed";
  const isBioBeats  = eventName.includes("BioBeats");
  const filtered = vendors.filter(v => !v.parentId);
  const capacityMax  = eventInfo?.capacity || 1;
  const capacityUsed = vendors.filter(v => CAPACITY_STATUSES.has(v.status) && !v.parentId).length;
  const capacityPct  = Math.round((capacityUsed / capacityMax) * 100);
  const dateLabel = isCanceled ? "CANCELED" : isCompleted ? "COMPLETED" : dateStatus === "today" ? "TODAY" : isPast ? "PAST" : "UPCOMING";
  const dateBadgeStyle = isCanceled
  ? { background: "#3d0a0a", color: "#e37e7e", border: "1px solid #6a1a1a" }
  : isCompleted ? { background: "#2d2a1e", color: "#e3c97e", border: "1px solid #52470a" }
  : dateStatus === "today" ? { background: "#2d1e08", color: "#f0a040", border: "1px solid #7a4a00" }
  : isPast ? { background: "#141e24", color: "#4a6a78", border: "1px solid #2a3a40" }
  : { background: "#1a3d2e", color: "#6ee3a8", border: "1px solid #0a5230" };
  const td = (idx) => ({ padding: "14px 18px", borderBottom: "1px solid #0a1828", background: idx % 2 === 0 ? "transparent" : "rgba(255,255,255,.01)" });
  return (
    <div style={{ borderRadius: 14, border: `1px solid ${open ? "#2a5070" : "#0e2030"}`, background: "#060f1a", marginBottom: 10, overflow: "hidden", borderLeft: isBioBeats && open ? "4px solid #16a8e4" : "1px solid #0e2030" }}>
      <div onClick={() => setOpen(!open)} style={{ padding: "18px 22px", display: "flex", alignItems: "center", cursor: "pointer", background: open ? "rgba(22,168,228,.05)" : "none", gap: 16 }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
            <span style={{ fontWeight: 700, fontSize: 16, color: "#c8dce8", fontFamily: "'Syne', sans-serif" }}>{eventName}</span>
            <span style={{ padding: "2px 9px", borderRadius: 10, fontSize: 10, fontWeight: 700, fontFamily: "'DM Mono',monospace", letterSpacing: "0.07em", ...dateBadgeStyle }}>{dateLabel}</span>
            {capacityPct >= 100 && !isCompleted && <span style={{ padding: "2px 9px", borderRadius: 10, fontSize: 10, fontWeight: 700, fontFamily: "'DM Mono',monospace", background: "#3d0a0a", color: "#e37e7e", border: "1px solid #6a1a1a" }}>SOLD OUT</span>}
          <span style={{ padding: "2px 9px", borderRadius: 10, fontSize: 10, fontWeight: 700, fontFamily: "'DM Mono',monospace", background: "rgba(22,168,228,0.08)", color: "#4a9ab0", border: "1px solid #1a4060" }}>{capacityUsed}/{capacityMax} filled</span>
          </div>
          <div style={{ marginTop: 5, display: "flex", gap: 16, flexWrap: "wrap" }}>
  <span style={{ fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#16a8e4" }}>
    {new Date(eventInfo.date + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
  </span>
  {(eventInfo.startTime || eventInfo.endTime) && (
    <span style={{ fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#16a8e4" }}>
      {eventInfo.startTime && formatTime(eventInfo.startTime)}
      {eventInfo.startTime && eventInfo.endTime && " – "}
      {eventInfo.endTime && formatTime(eventInfo.endTime)}
    </span>
  )}
  <span style={{ fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#16a8e4" }}>{eventInfo.address}</span>
  {eventInfo.costPerTable && (
    <span style={{ fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#16a8e4" }}>
      ${eventInfo.costPerTable.toLocaleString()} / table
    </span>
  )}
</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, paddingRight: 12 }}>
  
  <button onClick={e => { e.stopPropagation(); onEditEvent(eventName); }} style={{ padding: "5px 12px", borderRadius: 7, background: "none", border: "1px solid #2a5070", color: "#7ecfe3", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>✏️ Edit</button>
  <button onClick={e => { e.stopPropagation(); onAddVendor(eventName); }} style={{ padding: "5px 12px", borderRadius: 7, background: "linear-gradient(135deg,#0e8abf,#16a8e4)", border: "none", color: "#fff", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>+ Add</button>
</div>
        <span style={{ color: "#2a5a7a", transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform .2s" }}>⌄</span>
      </div>
      {open && (
        <div style={{ borderTop: "1px solid #0e2030", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#040e1a" }}>
                {["Name", "Company", "Pref", "Status", "Actions"].map(h => (
                  <th key={h} style={{ padding: "10px 18px", textAlign: "left", fontSize: 10, color: "#4a8a9a", letterSpacing: "0.08em" }}>{h.toUpperCase()}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((v, idx) => (
                <React.Fragment key={v.id}>
                  <tr className="vrow" style={{ background: q && (v.name.toLowerCase().includes(q) || (v.company && v.company.toLowerCase().includes(q))) ? "rgba(22,168,228,0.12)" : "transparent" }}>
                    <td style={td(idx)}><div style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 13, color: "#c8dce8" }}>{v.name}</div></td>
                    <td style={td(idx)}><div style={{ fontSize: 12, color: "#6a8aaa" }}>{v.company}</div></td>
                    <td style={td(idx)}><PaymentPrefBadge pref={v.paymentPref} /></td>
                    <td style={td(idx)}>
                      <select value={v.status} onChange={e => onStatusChange(v.id, e.target.value)} style={{ padding: "5px 10px", borderRadius: 20, border: `1px solid ${STATUS_STYLES[v.status].border}`, background: STATUS_STYLES[v.status].bg, color: STATUS_STYLES[v.status].color, fontSize: 11, fontWeight: 600, cursor: "pointer" }}>
                        {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </td>
                    <td style={td(idx)}>
                      <div style={{ display: "flex", gap: 5 }}>
                        <button className="abtn" onClick={() => onPaymentLinkSend(v)} style={{ padding: "5px 10px", borderRadius: 6, border: `1px solid ${v.linkSent ? "#5ae3a855" : "#16a8e455"}`, color: v.linkSent ? "#5ae3a8" : "#16a8e4", background: v.linkSent ? "rgba(90,227,168,0.07)" : "none", fontSize: 10, cursor: "pointer", fontWeight: 600 }}>
  {v.linkSent ? "✓ Sent" : "Pay Link"}
</button>
                        {v.paymentPref === "Credit Card on File" && v.status === "Confirmed" && <button className="abtn" onClick={() => onRunCC(v)} style={{ padding: "5px 10px", borderRadius: 6, border: "1px solid #a855f766", color: "#e879f9", background: "rgba(168,85,247,0.15)", fontSize: 10, cursor: "pointer", fontWeight: 600 }}>Run CC</button>}
                        <button className="abtn" onClick={() => onSplitModal(v)} style={{ padding: "5px 10px", borderRadius: 6, border: "1px solid #2a5a3a", color: "#5ae3a8", background: "none", fontSize: 10, cursor: "pointer", fontWeight: 600 }}>Split</button>
                        <button className="abtn" onClick={() => v.status === "Paid" && onReceiptModal(v)} disabled={v.status !== "Paid"} style={{ padding: "5px 10px", borderRadius: 6, border: `1px solid ${v.status === "Paid" ? "#1a4070" : "#0e2030"}`, color: v.status === "Paid" ? "#7ecfe3" : "#2a4060", background: "none", fontSize: 10, cursor: v.status === "Paid" ? "pointer" : "not-allowed", fontWeight: 600 }}>Receipt</button>
                        <button className="abtn" onClick={() => onEditVendor(v)} style={{ padding: "5px 8px", borderRadius: 6, border: "1px solid #1a3050", color: "#4a7a9a", background: "none", cursor: "pointer" }}>✏️</button>
                      </div>
                    </td>
                  </tr>
                  {allVendors.filter(col => col.parentId === v.id).map(col => (
                    <tr key={col.id} style={{ background: "rgba(22,168,228,.02)" }}>
                      <td style={{ ...td(idx), paddingLeft: 40 }}><div style={{ color: "#8aaac0", fontSize: 13 }}>↳ {col.name}</div></td>
                      <td style={td(idx)}><div style={{ fontSize: 11, color: "#4a6a8a" }}>{col.company || "Split Partner"}</div></td>
                      <td style={td(idx)}><PaymentPrefBadge pref={col.paymentPref} /></td>
                      <td style={td(idx)}>
                        <select value={col.status} onChange={e => onColleagueStatusChange(col.id, e.target.value)} style={{ padding: "4px 8px", borderRadius: 20, border: `1px solid ${STATUS_STYLES[col.status]?.border || "#1a4060"}`, background: STATUS_STYLES[col.status]?.bg || "none", color: STATUS_STYLES[col.status]?.color || "#fff", fontSize: 10, cursor: "pointer" }}>
                          {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                      </td>
                      <td style={td(idx)}>
                        <div style={{ display: "flex", gap: 5 }}>
                          <button onClick={() => onColleaguePaymentLinkSend(col)} style={{ padding: "4px 10px", borderRadius: 6, border: `1px solid ${col.linkSent ? "#5ae3a855" : "#16a8e433"}`, color: col.linkSent ? "#5ae3a8" : "#16a8e4", background: col.linkSent ? "rgba(90,227,168,0.07)" : "none", fontSize: 10, cursor: "pointer", fontWeight: 600 }}>
  {col.linkSent ? "✓ Sent" : "Pay Link"}
</button>
                          {col.paymentPref === "Credit Card on File" && col.status === "Confirmed" && <button onClick={() => onRunCC(col)} style={{ padding: "4px 10px", borderRadius: 6, border: "1px solid #a855f744", color: "#e879f9", background: "none", fontSize: 10, cursor: "pointer", fontWeight: 600 }}>Run CC</button>}
                          <button onClick={() => col.status === "Paid" && onReceiptModal(col)} disabled={col.status !== "Paid"} style={{ padding: "4px 10px", borderRadius: 6, border: `1px solid ${col.status === "Paid" ? "#1a4070" : "#0e2030"}`, color: col.status === "Paid" ? "#7ecfe3" : "#2a4060", background: "none", fontSize: 10, cursor: col.status === "Paid" ? "pointer" : "not-allowed", fontWeight: 600 }}>Receipt</button>
                          <button onClick={() => onEditVendor(col)} style={{ padding: "4px 8px", borderRadius: 6, border: "1px solid #1a305033", color: "#4a7a9a", background: "none", cursor: "pointer" }}>✏️</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ─── App ──────────────────────────────────────────────────────────────────────
export default function App() {
  const [vendors,         setVendors]         = useState([]);
  const [eventData,       setEventData]       = useState(INITIAL_EVENT_DATA);
  const [toasts,          setToasts]          = useState([]);
  const [searchQuery,     setSearchQuery]     = useState("");
  const [showPast,        setShowPast]        = useState(false);
  const [splitModal,      setSplitModal]      = useState(null);
  const [editVendorModal, setEditVendorModal] = useState(null);
  const [addModal,        setAddModal]        = useState(null);
  const [addEventModal,   setAddEventModal]   = useState(false);
  const [editEventModal,  setEditEventModal]  = useState(null);
  const [dbLoaded,        setDbLoaded]        = useState(false);

  const { vendors: ccVendors, isLoading: ccLoading, isAuthenticated: ccAuthed, login: ccLogin, logout: ccLogout, refresh: ccRefresh } = useCCVendors();

  // ── Load data from MongoDB on startup ────────────────────────────────────────
  useEffect(() => {
    async function loadFromDB() {
      try {
        const vRes = await fetch(`${API}/vendors`);
        const vData = await vRes.json();
        if (vData.length > 0) {
          setVendors(vData);
        } else {
          setVendors([]);
        }

        const eRes = await fetch(`${API}/events`);
        const eData = await eRes.json();
        if (eData.length > 0) {
          const eventMap = {};
          eData.forEach(e => { const { name, _id, ...rest } = e; eventMap[name] = rest; });
          setEventData(eventMap);
        } else {
          setEventData({});
        }
        setDbLoaded(true);
      } catch (err) {
        console.error("DB load error:", err);
        setVendors(initialVendors);
        setDbLoaded(true);
      }
    }

    loadFromDB();

    // Poll every 10 seconds for real-time sync
    const interval = setInterval(async () => {
      try {
        const vRes = await fetch(`${API}/vendors`);
        const vData = await vRes.json();
        if (vData.length > 0) setVendors(vData);

        const eRes = await fetch(`${API}/events`);
        const eData = await eRes.json();
        if (eData.length > 0) {
          const eventMap = {};
          eData.forEach(e => { const { name, _id, ...rest } = e; eventMap[name] = rest; });
          setEventData(eventMap);
        }
      } catch (err) {
        console.error("Poll error:", err);
      }
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const upcomingEvents = Object.keys(eventData).filter(e => {
  const info = eventData[e];
  return info && (info.status === "Upcoming" || getDateStatus(info.date) === "upcoming" || getDateStatus(info.date) === "today");
}).sort((a, b) => new Date(eventData[a].date) - new Date(eventData[b].date));
  const pastEvents = Object.keys(eventData).filter(e => {
    const info = eventData[e];
    return info && (info.status === "Completed" || getDateStatus(info.date) === "completed");
  });
  const displayed = (showPast ? Object.keys(eventData) : upcomingEvents)
  .sort((a, b) => new Date(eventData[a].date + "T00:00:00") - new Date(eventData[b].date + "T00:00:00"));

  const upcomingSet             = new Set(upcomingEvents);
  const filteredUpcomingVendors = vendors.filter(v => upcomingSet.has(v.event));
  const confirmedCount          = filteredUpcomingVendors.filter(v => ["Confirmed", "Paid"].includes(v.status)).length;
  const pipelineCount           = filteredUpcomingVendors.filter(v => v.status === "Waitlisted").length;
  const totalCapacity           = upcomingEvents.reduce((acc, e) => acc + (eventData[e]?.capacity || 0), 0);
  const capacityPct             = totalCapacity > 0 ? Math.round((confirmedCount / totalCapacity) * 100) : 0;

  const pushToast = useCallback((message, type = "info") => {
    setToasts(prev => [...prev, { id: Date.now() + Math.random(), message, type }]);
  }, []);

  const handleStatusChange = async (id, status) => {
  const update = { status };
  if (status === "Paid") {
    update.paymentDate = new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  }
  setVendors(prev => prev.map(v => v.id === id ? { ...v, ...update } : v));
  await dbUpdateVendor(id, update);
};

  const handleSplitSend = async (vendor, colleagues, primaryAmt) => {
    const newOnes = colleagues.filter(c => c.name || c.email).map(c => ({
      ...c, id: Date.now() + Math.random(), parentId: vendor.id, event: vendor.event, status: "Confirmed", linkSent: false, paymentPref: c.paymentPref || "Payment Link"
    }));
    setVendors(prev => [...prev.map(v => v.id === vendor.id ? { ...v, status: "Confirmed" } : v), ...newOnes]);
    await dbUpdateVendor(vendor.id, { status: "Confirmed", amt: primaryAmt });
    for (const n of newOnes) { await dbSaveVendor(n); }
    setSplitModal(null);
    pushToast(`Splits successfully updated for ${vendor.name}`, "success");
  };

  const handleAddVendor = async (v) => {
    const newVendor = { ...v, id: Date.now(), status: "Confirmed", linkSent: false };
    setVendors(prev => [...prev, newVendor]);
    await dbSaveVendor(newVendor);
    pushToast("New vendor profile added.", "success");
  };

  const handleRunCC = async (v) => {
  pushToast(`Sending charge request for ${v.name}...`, "info");
  try {
    const res = await fetch("https://bioev-portal-production.up.railway.app/api/send-cc-notification", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        vendorName: v.name,
        vendorEmail: v.billingEmail || v.email,
        amount: String(Number(v.customAmount || eventData[v.event]?.costPerTable || 0).toFixed(2)),
        eventName: v.event,
      }),
    });
    const data = await res.json();
    if (data.success) {
      pushToast(`✓ Charge request sent for ${v.name}`, "success");
    } else {
      pushToast(`✗ Failed to send request`, "error");
    }
  } catch (err) {
    pushToast(`✗ Network error`, "error");
  }
};

  const handlePayLink = async (v) => {
  pushToast(`Generating payment link for ${v.name}...`, "info");
  try {
    const res  = await fetch("https://bioev-portal-production.up.railway.app/api/payments/create-pay-link", {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  vendorId:   v.id,
  amount: String(Number(v.amt || v.customAmount || eventData[v.event]?.costPerTable || 0).toFixed(2)),
  description: v.event,
  email:      v.billingEmail || v.email,
  vendorName: v.name,
  eventName:  v.event,
  eventDate:  eventData[v.event]?.date || "",
}),
    });
    const data = await res.json();

    if (data.success) {
      // const payUrl = data.payUrlBase + "?token=" + data.token;

      // Email the link to the vendor
      const emailRes = await fetch("https://bioev-portal-production.up.railway.app/api/send-pay-link", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({
          vendorEmail: v.billingEmail || v.email,
          vendorName:  v.name,
          paymentLink: `https://portal.bio-ev.com/pay?vendorId=${v.id}&amount=${v.amt || v.customAmount || eventData[v.event]?.costPerTable}&event=${encodeURIComponent(v.event)}&vendorEmail=${encodeURIComponent(v.billingEmail || v.email)}&vendorName=${encodeURIComponent(v.name)}`,
          amount: v.amt || v.customAmount || eventData[v.event]?.costPerTable,
          eventName: v.event,
        }),
      });
      const emailData = await emailRes.json();

      if (emailData.success) {
        setVendors(prev => prev.map(item => item.id === v.id ? { ...item, linkSent: true } : item));
        await dbUpdateVendor(v.id, { linkSent: true, pendingEvent: v.event });
        pushToast(`✓ Payment link emailed to ${v.billingEmail || v.email}`, "success");
      } else {
        pushToast(`✗ Link generated but email failed: ${emailData.error}`, "error");
      }
    } else {
      pushToast(`✗ Could not generate link for ${v.name}: ${data.errorText}`, "error");
    }
  } catch (err) {
    pushToast(`Network error: ${err.message}`, "error");
  }
};

const handleSendReceipt = async (v) => {
  pushToast(`Sending receipt to ${v.billingEmail || v.email}...`, "info");
  try {
    const res = await fetch("https://bioev-portal-production.up.railway.app/api/send-receipt", {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  vendorEmail:   v.billingEmail || v.email,
  vendorName:    v.name,
  amount:        v.customAmount || eventData[v.event]?.costPerTable,
  eventName:     v.event,
  eventDate:     eventData[v.event]?.date,
  paymentDate: v.paymentDate || new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }),
  transactionId: v.transactionId || null,
}),
    });
    const data = await res.json();
    if (data.success) {
      pushToast(`✓ Receipt sent to ${v.billingEmail || v.email}`, "success");
    } else {
      pushToast(`✗ Failed to send receipt: ${data.error}`, "error");
    }
  } catch (err) {
    pushToast(`Network error: ${err.message}`, "error");
  }
};

const handleAddEvent = async (name, details) => {
    const newEvent = { date: details.date, costPerTable: details.cost, capacity: details.capacity, status: "Upcoming", address: details.address, startTime: details.startTime || "", endTime: details.endTime || "" };
    setEventData(prev => ({ ...prev, [name]: newEvent }));
    await dbSaveEvent(name, newEvent);
    setAddEventModal(false);
    pushToast(`${name} has been added to the series.`, "success");
  };

  const handleEditEvent = async (name, details) => {
    setEventData(prev => ({ ...prev, [name]: { ...prev[name], ...details } }));
    await dbSaveEvent(name, { ...eventData[name], ...details });
    setEditEventModal(null);
    pushToast(`${name} has been updated.`, "success");
  };

  if (!dbLoaded) return (
    <div style={{ minHeight: "100vh", background: "#040e1a", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ fontFamily: "'DM Mono', monospace", color: "#16a8e4", fontSize: 14 }}>Loading Bio-EV Portal...</div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: "#040e1a", color: "#c8dce8", fontFamily: "'DM Sans', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=DM+Mono:wght@400;500&family=Syne:wght@700;800&display=swap');
        @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @keyframes pulse  { 0%,100% { opacity: 1; } 50% { opacity: 0.4; } }
        select option { background: #0d2137; color: #fff; }
        .vrow:hover { background: rgba(22,168,228,0.03) !important; transition: background 0.15s; }
        .abtn:hover { opacity: 0.8; transform: translateY(-1px); }
      `}</style>

      <div style={{ padding: "18px 32px 14px", borderBottom: "1px solid #0e2030", background: "linear-gradient(180deg,#061422,#040e1a)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 20, color: "#c8dce8", letterSpacing: "-0.02em" }}>Bio-EV <span style={{ color: "#16a8e4" }}>Vendor Portal</span></div>
          <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: "#2a5a7a", letterSpacing: "0.1em", marginTop: 2 }}>EVENT VENDOR MANAGEMENT</div>
        </div>
        <div style={{ display: "flex", gap: 40, alignItems: "center" }}>
          <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
            {[{ label: "PIPELINE", value: pipelineCount }, { label: "CONFIRMED", value: confirmedCount }, { label: "CAPACITY", value: `${capacityPct}%` }].map(({ label, value }) => (
              <div key={label} style={{ textAlign: "center" }}>
                <div style={{ fontFamily: "'Syne', sans-serif", fontSize: 18, fontWeight: 700, color: "#16a8e4" }}>{value}</div>
                <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, color: "#2a5a7a", letterSpacing: "0.1em" }}>{label}</div>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 15, alignItems: "center" }}>
            <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search vendors..." style={{ background: "#0a1525", border: "1px solid #1a3050", borderRadius: 8, padding: "10px 15px", color: "#c8dce8", width: 220, fontSize: 13, outline: "none" }} />
            <button onClick={() => setAddEventModal(true)} style={{ background: "#16a8e4", color: "white", border: "none", borderRadius: 8, padding: "10px 18px", fontWeight: 600, cursor: "pointer", fontSize: 13 }}>+ Add Event</button>
          </div>
        </div>
      </div>

      <CCStatusBanner isAuthenticated={ccAuthed} isLoading={ccLoading} ccVendorCount={ccVendors.length} onLogin={ccLogin} onLogout={ccLogout} onRefresh={ccRefresh} />

      <div style={{ padding: "15px 32px", display: "flex", gap: 10 }}>
        <button onClick={() => setShowPast(false)} style={{ background: !showPast ? "rgba(22,168,228,.1)" : "none", border: `1px solid ${!showPast ? "#16a8e4" : "#1a4060"}`, color: !showPast ? "#16a8e4" : "#4a8a9a", padding: "6px 14px", borderRadius: 20, cursor: "pointer", fontSize: 11, fontWeight: 600 }}>UPCOMING</button>
        <button onClick={() => setShowPast(true)}  style={{ background:  showPast ? "rgba(22,168,228,.1)" : "none", border: `1px solid ${ showPast ? "#16a8e4" : "#1a4060"}`, color:  showPast ? "#16a8e4" : "#4a8a9a", padding: "6px 14px", borderRadius: 20, cursor: "pointer", fontSize: 11, fontWeight: 600 }}>ALL EVENTS</button>
      </div>

      <div style={{ padding: "0 32px 40px" }}>
        {displayed.map(e => (
          <EventAccordion
            key={e} eventName={e} eventInfo={eventData[e]}
            vendors={vendors.filter(v => v.event === e)} allVendors={vendors}
            searchQuery={searchQuery}
            onStatusChange={handleStatusChange}
            onColleagueStatusChange={handleStatusChange}
            onRunCC={handleRunCC}
            onEditVendor={setEditVendorModal}
            onAddVendor={setAddModal}
            onEditEvent={name => setEditEventModal({ name, info: eventData[name] })}
            onReceiptModal={handleSendReceipt}
            onPaymentLinkSend={handlePayLink}
onColleaguePaymentLinkSend={handlePayLink}
            onSplitModal={v => setSplitModal({ vendor: v, eventInfo: eventData[v.event], initialColleagues: vendors.filter(c => c.parentId === v.id) })}
          />
        ))}
      </div>

      {splitModal      && <SplitPaymentModal key={splitModal.vendor.id} vendor={splitModal.vendor} eventInfo={splitModal.eventInfo} initialColleagues={splitModal.initialColleagues} ccVendors={ccVendors} onClose={() => setSplitModal(null)} onSend={handleSplitSend} />}
      {editVendorModal && <EditVendorModal vendor={editVendorModal} onClose={() => setEditVendorModal(null)} onDelete={async (id) => { const deletedVendor = vendors.find(v => v.id === id); await dbDeleteVendor(id); setVendors(prev => { const remaining = prev.filter(v => v.id !== id); const parentId = deletedVendor?.parentId; if (parentId) { const parent = remaining.find(v => v.id === parentId); const siblings = remaining.filter(v => v.parentId === parentId); const total = parent ? (eventData[parent.event]?.costPerTable || 0) : 0; const splitAmt = siblings.length > 0 ? Math.round((total / (siblings.length + 1)) * 100) / 100 : total; return remaining.map(v => { if (v.id === parentId) return { ...v, amt: splitAmt }; if (v.parentId === parentId) return { ...v, amt: splitAmt }; return v; }); } return remaining; }); setEditVendorModal(null); pushToast("Vendor deleted.", "success"); }} onSave={async (id, f) => { setVendors(prev => prev.map(v => v.id === id ? { ...v, ...f } : v)); await dbUpdateVendor(id, f); setEditVendorModal(null); pushToast("Updated.", "success"); }} />}
      {addModal        && <AddVendorModal upcomingEvents={upcomingEvents} pastEvents={pastEvents} defaultEvent={typeof addModal === "string" ? addModal : null} ccVendors={ccVendors} onClose={() => setAddModal(null)} onAdd={handleAddVendor} />}
      {addEventModal   && <AddEventModal onClose={() => setAddEventModal(false)} onAdd={handleAddEvent} />}
      {editEventModal && <EditEventModal eventName={editEventModal.name} eventInfo={editEventModal.info} onClose={() => setEditEventModal(null)} onSave={handleEditEvent} onDelete={async (name) => { setEventData(prev => { const updated = { ...prev }; delete updated[name]; return updated; }); await dbDeleteEvent(name); setEditEventModal(null); pushToast(`${name} deleted.`, "success"); }} />}

      <ToastStack toasts={toasts} onClose={id => setToasts(prev => prev.filter(t => t.id !== id))} />
    </div>
  );
}